
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import AddIcon from '../../../Icons/AddIcon.vue';
/**
- Card is clickable and get the function thru @click-card
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralAddCard',
  components: {
    EuCard,
    AddIcon
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleCardClick(e: any) {
      /**
       * Method to click card
       * @event click-card
       * @type {function}
       */
      this.$emit('click-card', e);
    },
    handleClick(e: any) {
      /**
       * Method to click add icon
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
